import { IusersReviews } from "../../interface/UserReviewsInterface";

export const usersReviews: IusersReviews[] = [
    {
        id: 1,
        username: "Mr Moss",
        comment:
            "I was skeptical at first about hiring a web developer, but you exceeded all of my expectations. Thank you for all of your hard work!",
    },
    {
        id: 2,
        username: "Ugochukwu P.",
        comment:
            "I have worked with several web developers in the past, but none have been as dedicated and skilled as you. Your attention to detail is impressive.",
    },
    {
        id: 3,
        username: "Paul Slick",
        comment:
            "As a fellow web developer, I have to say that your work is top-notch. The website you built is not only visually stunning, but it also performs flawlessly.",
    },
    {
        id: 4,
        username: "Francis Uzor",
        comment:
            "I am blown away by the beautiful design and functionality of the website you created. You truly have a talent for web development!",
    },
];
